import React from 'react';
import { FormattedMessage } from 'react-intl';
import { makeStyles, Typography } from '@material-ui/core';
import { getTextInBold } from '~/modules/common/util';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: theme.palette.grey[100],
    color: theme.palette.text.secondary,
    padding: theme.spacing(1, 2),
    margin: theme.spacing(-2, -2, 2, -2)
  }
}));

const ProjectDocumentsUserHint = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Typography variant="body2">
        <FormattedMessage
          id="attachments.projectDocumentsUserHint"
          values={getTextInBold()}
        />
      </Typography>
    </div>
  );
};

export default ProjectDocumentsUserHint;
